// eslint-disable-next-line
import React from 'react';
import { Text, Box, Flex, theme, Spinner, Panel } from '@xometry/xometry_loft';
import DecisioningTemplate from '../../../../components/DecisioningTemplate';
import DecisioningStatesConfig from './decisioningStatesConfig';

interface props {
  decision: string;
  email?: string;
  terms?: {
    approvedLimit: number;
    netTerms: string;
  };
}

const DecisioningStates = ({ decision, email, terms }: props) => {
  const decisionState = DecisioningStatesConfig[decision];

  return (
    <Box>
      <Box margin="auto">
        <Flex>
          <Panel
            kind="primary"
            textAlign="center"
            width="578px"
            minHeight="269px"
          >
            {decisionState.type === 'loadingState' && (
              <>
                <Text
                  kind="panel-title"
                  display="block"
                  marginBottom="12px"
                  fontWeight={theme.fontWeights.semibold}
                >
                  {decisionState.headline}
                </Text>
                <Text kind="body" display="block" marginBottom="16px">
                  {decisionState.text}
                </Text>
                <Spinner scale="full-screen" />
              </>
            )}
            {decisionState.type !== 'loadingState' && (
              <DecisioningTemplate
                decision={decisionState}
                // handleActionStep={() => console.log('decisionssss')}
                email={email}
                terms={terms}
              />
            )}
          </Panel>
        </Flex>
      </Box>
    </Box>
  );
};

export default DecisioningStates;
